<script>
    import {showDialogLogin} from "../../../js/stores";
    import {API_URL} from "../../../../env";
    import {addAlert} from "../../../js/alert";

    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    let inputEmail = ""
    let emailBad = false

    let errorReason = ""

    let isFetching = false
    async function send() {
        if (isFetching) return;
        isFetching = true

        errorReason = ""
        if (!emailRegex.test(inputEmail)) {
            errorReason = "Zlý tvar e-mailu"
            emailBad = true;
            return isFetching = false
        }

        let body = {
            email: inputEmail
        }

        const res = await fetch(API_URL + "/users/sendForgottenPasswordToken", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            if (res.status === 400) {
                errorReason = "Zlý e-mail"
                emailBad = true;
            }
            else {
                addAlert("danger", "Chyba", "Chyba pri odosielaní emailu, skúste to prosím znova.")
            }

            isFetching = false
            return
        }

        showDialogLogin.set({show: true, type: "check", data: {title: "E-mail bol odoslaný", text: "Na zadaný e-mail sme Vám zaslali odkaz na obnovenie zabudnutého hesla."}})
        isFetching = false
    }
</script>

<div class="dc-title mb-3">Zabudnuté heslo?</div>
<p class="mb-4">Zadajte svoj e-mail a pošleme vám odkaz na obnovenie.</p>

<div class="input-group mb-2">
    <label for="email">E-mail</label>
    <input class:unfilled={emailBad} id="email" name="email" type="email" placeholder="E-mail" bind:value={inputEmail}>
</div>

<p class="text-danger text-right">{errorReason}</p>

<div class="d-flex justify-content-center mt-4">
    <button class="btn btn-slate-50" on:click={send}>
        {#if isFetching}
            <i class="fas fa-fw fa-spinner-third fa-spin mr-2"></i>
        {:else}
            <i class="fas fa-fw fa-check mr-2"></i>
        {/if}
        Potvrdiť
    </button>
</div>

<div class="d-flex justify-content-center mt-4">
    <button class="btn btn-link" type="button" on:click={() => showDialogLogin.set({show: true, type: "login"})}>Späť na prihlásenie</button>
</div>

<style>
    .dc-title {
        font-size: 1.5rem;
        font-weight: 600;
    }
</style>